<template>
  <div>
    <div class="wz-page-header">
      <h1 class="wz-page-title">Roles de firmante</h1>
    </div>

    <!-- Cobertura: lo que RRHH necesita ver antes de generar documentos -->
    <wz-card title="Cobertura de firmantes">
      <p class="text-muted text-sm mb-2">
        Roles que exigen los tipos de documento de cada empresa y que nadie ocupa en ella. Mientras aparezcan aquí,
        generar esos documentos para esa empresa va a fallar.
      </p>
      <p v-if="!gaps.length" class="mb-0"><i class="ri-checkbox-circle-line mr-1"></i>Todas las empresas tienen cubiertos sus roles exigidos.</p>
      <wz-table v-else>
        <thead>
          <tr>
            <th>Empresa</th>
            <th>Rol sin asignar</th>
            <th>Lo exigen</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="g in gaps" :key="g.companyId + '-' + g.roleId">
            <td>{{ g.companyName }}</td>
            <td>{{ g.roleName }} <small class="text-muted"><code>{{ g.roleCode }}</code></small></td>
            <td>{{ g.documentTypes.join(', ') }}</td>
            <td>
              <router-link :to="{ name: 'company-edit', params: { id: g.companyId } }">Asignar</router-link>
            </td>
          </tr>
        </tbody>
      </wz-table>
    </wz-card>

    <!-- Catálogo -->
    <wz-card title="Catálogo" class="mt-3">
      <p class="text-muted text-sm mb-3">
        Un rol <strong>estándar</strong> está disponible para todas las empresas. Un rol <strong>propio</strong> es de
        una sola empresa (por ejemplo, quien firma los documentos de seguridad en una planta).
      </p>
      <div class="flex flex-wrap -mx-2">
        <div class="w-full md:w-1/4 mb-3 px-2">
          <wz-input v-model="form.code" label="Código" placeholder="JEFE_PLANTA" />
        </div>
        <div class="w-full md:w-1/3 mb-3 px-2">
          <wz-input v-model="form.name" label="Nombre" placeholder="Jefe de planta" />
        </div>
        <div class="w-full md:w-1/3 mb-3 px-2">
          <label class="wz-form-label">Empresa</label>
          <wz-select v-model="form.companyId" :items="companyOptions" defaultOption="Estándar (todas)" />
        </div>
      </div>
      <div class="flex justify-end">
        <wz-button variant="primary" :disabled="!form.code || !form.name" @click="create">Agregar rol</wz-button>
      </div>

      <wz-table class="mt-3">
        <thead>
          <tr>
            <th>Código</th>
            <th>Nombre</th>
            <th>Alcance</th>
            <th>Estado</th>
            <th>Opciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="r in roles" :key="r.id">
            <td><code>{{ r.code }}</code></td>
            <td>{{ r.name }}</td>
            <td>{{ r.standard ? 'Estándar' : `Propio de ${r.companyName}` }}</td>
            <td>
              <wz-badge :variant="r.status === 1 ? 'success' : 'secondary'" pill>{{ r.status === 1 ? 'Activo' : 'Inactivo' }}</wz-badge>
            </td>
            <td style="text-align: center;">
              <wz-dropdown :items="[{ key: 'rename', label: 'Renombrar' }, { key: 'status', label: r.status === 1 ? 'Desactivar' : 'Activar' }]"
                           placement="left" @click="handleAction(r, $event)" />
            </td>
          </tr>
        </tbody>
      </wz-table>
    </wz-card>
  </div>
</template>

<script>
import { Alert } from '@wizepe/wizeui'
import { SignerService, CompanyService } from '@/core/services'

export default {
  name: 'SignerRoleList',
  data() {
    return {
      roles: [],
      gaps: [],
      companies: [],
      form: { code: null, name: null, companyId: null },
    }
  },
  computed: {
    companyOptions() { return this.companies.map(c => ({ key: c.id, label: c.name })) },
  },
  async created() {
    try {
      this.companies = (await CompanyService.listAll()).payload || []
    } catch (e) {
      console.error('Error cargando empresas', e)
    }
    this.load()
  },
  methods: {
    async load() {
      try {
        const [roles, gaps] = await Promise.all([SignerService.listRoles(null), SignerService.coverage(null)])
        this.roles = roles.payload || []
        this.gaps = gaps.payload || []
      } catch (e) {
        Alert.error(e.errors ? e.errors.message : 'Error al cargar los roles')
      }
    },
    async create() {
      try {
        await SignerService.createRole({ code: this.form.code, name: this.form.name, companyId: this.form.companyId || null })
        Alert.success('Rol creado')
        this.form = { code: null, name: null, companyId: null }
        this.load()
      } catch (e) {
        Alert.error(e.errors ? e.errors.message : 'Error al crear el rol')
      }
    },
    async handleAction(r, item) {
      try {
        if (item.key === 'rename') {
          const name = window.prompt('Nuevo nombre del rol', r.name)
          if (!name) return
          await SignerService.renameRole(r.id, name)
        }
        if (item.key === 'status') await SignerService.roleStatus(r.id, r.status === 1 ? 0 : 1)
        this.load()
      } catch (e) {
        Alert.error(e.errors ? e.errors.message : 'Error al actualizar el rol')
      }
    },
  },
}
</script>
